// @flow
import React, { useRef, useEffect, useState } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

type PanelPropsType = {
    isOpen?: boolean,
    children?: any,
    title: ?string,
    onOpen?: string => void,
    id: string
};

export const AccordionPanel = ({ id, children, title, isOpen, onOpen }: PanelPropsType) => {
    const [contentHeight, setContentHeight] = useState("0px");
    const contentSection = useRef(null);
    const content = useRef();
    const togglePanel = () => {
        if (contentHeight === "0px") {
            // Measure the contents height
            const sectionHeight = contentSection.current.scrollHeight;
            setContentHeight(`${ sectionHeight + 1 }px`);
            onOpen(id);
        } else {
            setContentHeight("0px");
        }
    };

    useEffect(
        () => {
            if (isOpen) {
                const sectionHeight = contentSection.current.scrollHeight;
                setContentHeight(`${ sectionHeight + 1 }px`);
            }
        }, [isOpen]);

    let observer;
    useEffect(() => {
        if (!observer) {
            const config = { attributes: true, childList: true, subtree: true };
            // Callback function to execute when mutations are observed
            const callback = (mutationsList, observer) => {
                if (contentHeight && contentHeight !== "0px") {
                    console.log("RESIZE");
                    const sectionHeight = contentSection.current.scrollHeight;
                    setContentHeight(`${ sectionHeight + 1 }px`);
                }
            };
            // Create an observer instance linked to the callback function
            observer = new MutationObserver(callback);
            // Start observing the target node for configured mutations
            observer.observe(content.current, config);
        }
        // Stop Observing on unmount
        return () => {
            observer.disconnect();
        };
    }, [contentHeight]);


    return (
        <section id={ id } className={ "accordion-panel" }>
            <div className={ "accordion-panel--button" }
                 onClick={ togglePanel }>
                <div className={ "accordion-panel--button-content-wrapper" }>
                    <div>
                        { title }
                    </div>
                    <div
                        className={ classNames("accordion-panel--chevron", { "is-open": contentHeight !== "0px" }) }
                    >
                        <FontAwesomeIcon
                            icon={ icons.faChevronDown }/>
                    </div>
                </div>
            </div>
            <div ref={ contentSection } style={ { height: contentHeight } } className={ "accordion-panel--content" }>
                <div ref={ content } className={ "accordion-panel--content-wrapper" }>
                    { children }
                </div>
            </div>
        </section>
    );
};

type PropsType = {
    children: any,
    openExclusive: ?boolean
};

export const Accordion = ({ children }: PropsType) => {
    const checkPanelStati = (id) => {
        console.log(`panel ${ id } is opening`);
    };

    return (
        <article className={ "accordion" }>
            {
                [...children]
                    .map((child, i) => React.cloneElement(child, {
                        key: i,
                        onOpen: checkPanelStati
                    }))
            }
        </article>
    );
};


